import React from "react";
import classNames from "classnames";

import { Props } from "./types";
import styles from "./styles.scss";

function MilestoneIcon({ className, style, milestone }: Props) {
  const now = new Date();
  const hasEndDate = !!milestone && !!milestone.endDate;
  const isLate =
    hasEndDate &&
    new Date(milestone!.endDate!) <
      new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0);
  const isCompleted = milestone && milestone.state === "DONE";
  const isUnscheduled = !!milestone && !milestone.endDate;

  return (
    <svg
      className={classNames(className, {
        [styles.completed]: isCompleted,
        [styles.unscheduled]: isUnscheduled,
      })}
      style={
        isCompleted
          ? { ...style, fill: "#98d292" }
          : isLate
            ? { ...style, fill: "#FF0429FF" }
            : isUnscheduled
              ? { ...style, fill: "rgba(158, 180, 191, 0.2)" }
              : style
      }
      viewBox="0 -1 15 19"
    >
      <path
        d="M21.41,5.293c-.146.024-.3.047-.467.066a27.813,27.813,0,0,1-2.859.245,17.362,17.362,0,0,1-3.69-.576,18.072,18.072,0,0,0-3.8-.528c-2.652,0-3.553.571-3.647.632l-.193.137v16.67a.674.674,0,0,0,.58.675.66.66,0,0,0,.741-.656V14.673a.383.383,0,0,1,.3-.373,11.449,11.449,0,0,1,2.218-.184,17.672,17.672,0,0,1,3.614.731,16.635,16.635,0,0,0,3.935.543,22.37,22.37,0,0,0,3.388-.311.38.38,0,0,0,.326-.373V5.665A.384.384,0,0,0,21.41,5.293Z"
        transform="translate(-6.75 -4.5)"
      />
    </svg>
  );
}

export { MilestoneIcon };
